import React from 'react'
import defaultTheme from '@ntuctech/devex-tangram/Theme/defaultTheme'

const SvgCheckBoxUnselected = ({ title, ...props }) => (
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    {title ? <title>{title}</title> : null}
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect
        id="Rectangle-Copy-3"
        stroke={defaultTheme.ColorBaseBrandPrimary500}
        x="0.5"
        y="0.5"
        width="15"
        height="15"
        rx="2"
      />
    </g>
  </svg>
)

export default SvgCheckBoxUnselected
